import _ from 'lodash';

const mutations = {};

/**
 * 포인트 전환 단계 저장
 * @param {*} state
 * @param {String} value
 */
mutations.SET_EXCHANGESTEP = (state, value) => {
  state.exchange.exchangeStep = value;
};

/**
 * 전환 비율 저장
 * @param {*} state
 * @param {Array} value
 */
mutations.SET_EXCHANGECURRENCY = (state, value) => {
  state.exchange.exchangeCurrency = value;
};

/**
 * 전환 포인트 저장
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_EXCHANGEPOINT = (state, value) => {
  state.exchange.exchangeRequest = value;
};

/**
 * 포인트 전환 정보
 * @param {*} state
 * @param {Array} value
 */
mutations.GET_EXCHANGEINIT = (state, value) => {
  state.exchange.exchangeInit = value;
  if (value.telNo) {
    const telNoArr = _.split(value.telNo, '-');
    state.exchange.exchangeInit.telNoFront = telNoArr[0];
    state.exchange.exchangeInit.telNoMiddle = telNoArr[1];
    state.exchange.exchangeInit.telNoBack = telNoArr[2];
  } else {
    state.exchange.exchangeInit.telNoFront = '010';
    state.exchange.exchangeInit.telNoMiddle = '';
    state.exchange.exchangeInit.telNoBack = '';
  }
  if (value.isCheckedAccountNo) {
    state.exchange.isStateAccount = value.isCheckedAccountNo;
    state.exchange.isDisplayAccount = value.isCheckedAccountNo;
    state.exchange.bankSelect = _.indexOf(state.exchange.bankNameList, value.bankName);
  }

  state.exchange.exchangeRequest.zipCode = value.zipCode || '';
  state.exchange.exchangeRequest.address1 = value.address1 || '';
  state.exchange.exchangeRequest.address2 = value.address2 || '';
  state.exchange.exchangeRequest.telNo = value.telNo || '';
  if (value.zipCode && value.address1 && value.address2 && value.telNo) {
    state.exchange.isStateContact = true;
  }
};

/**
 * 우편번호 변경
 * @param {*} state
 * @param {String} value
 */
mutations.SET_ZIPCODE = (state, value) => {
  state.exchange.exchangeRequest.zipCode = value;
};

/**
 * 기본 주소 변경
 * @param {*} state
 * @param {String} value
 */
mutations.SET_ADDRESS1 = (state, value) => {
  state.exchange.exchangeRequest.address1 = value;
};

/**
 * 상세 주소 변경
 * @param {*} state
 * @param {String} value
 */
mutations.SET_ADDRESS2 = (state, value) => {
  state.exchange.exchangeRequest.address2 = value;
};

/**
 * 연락처 앞자리 변경
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_TELNOFRONT = (state, value) => {
  state.exchange.exchangeInit.telNoFront = value;
};

/**
 * 연락처 중간자리 변경
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_TELNOMIDDLE = (state, value) => {
  state.exchange.exchangeInit.telNoMiddle = value;
};

/**
 * 연락처 끝자리 변경
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_TELNOBACK = (state, value) => {
  state.exchange.exchangeInit.telNoBack = value;
};

/**
 * 연락처 변경
 * @param {*} state
 * @param {String} value
 */
mutations.SET_TELNO = (state, value) => {
  state.exchange.exchangeInit.telNo = value;
  state.exchange.exchangeRequest.telNo = value;
};

/**
 * 연락처 입력 상태 정보
 * @param {*} state
 */
mutations.SET_EXCHANGECONTACTSTATE = (state) => {
  state.exchange.isStateContact =
    state.exchange.exchangeRequest.telNo !== '' &&
    state.exchange.exchangeRequest.address1 !== '' &&
    state.exchange.exchangeRequest.address2 !== '' &&
    state.exchange.exchangeRequest.zipCode !== '';
};

/**
 * 포인트 전환 신청 가능 은행 목록
 * @param {*} state
 * @param {object} value
 */
mutations.GET_BANKLIST = (state, value) => {
  state.exchange.bankNameList = _.map(value, 'bankName');
  state.exchange.bankList = value;
};

/**
 * 은행명 변경
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_BANKNAME = (state, value) => {
  state.exchange.bankSelect = value;
  state.exchange.exchangeAccountRequest.bankCode = state.exchange.bankList[value].bankCode;
};

/**
 * 은행명 선택 정보
 * @param {*} state
 * @param {String} value
 */
mutations.SET_BANKSELECT = (state, value) => {
  let index;
  index = value ? _.indexOf(state.exchange.bankNameList, value) : -1;
  state.exchange.bankSelect = index;
  state.exchange.exchangeAccountRequest.bankCode = value ? state.exchange.bankList[index].bankCode : null;
};

/**
 * 계좌번호 변경
 * @param {*} state
 * @param {String} value
 */
mutations.SET_ACCOUNTNO = (state, value) => {
  state.exchange.exchangeAccountRequest.accountNo = value;
};

/**
 * 계좌번호 인증 완료
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_EXCHANGEACCOUNT = (state, value) => {
  state.exchange.exchangeRequest.bankCode = value.bankCode;
  state.exchange.exchangeRequest.accountNo = value.accountNo;
};

/**
 * 계좌정보 인증 화면 상태 변경
 * @param {*} state
 * @param {Boolean} value
 */
mutations.SET_EXCHANGEACCOUNTDISPLAY = (state, value) => {
  state.exchange.isDisplayAccount = value;
};

/**
 * 계좌정보 인증 상태 변경
 * @param {*} state
 * @param {Boolean} value
 */
mutations.SET_EXCHANGEACCOUNTSTATE = (state, value) => {
  state.exchange.isStateAccount = value;
};

/**
 * 계좌정보 저장
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_EXCHANGEACCOUNTREGIST = (state, value) => {
  var item = state.exchange.exchangeList.list[state.exchange.exchangeDetail];
  item.bankName = _.find(state.exchange.bankList, { bankCode: value.bankCode }).bankName;
  item.accountNo = value.accountNo;
  state.exchange.isDetailAccount = false;
  state.exchange.isStateAccount = false;
  state.exchange.exchangeRequest = {};
};

/**
 * exchange 내역
 * @param {*} state
 * @param {Object} value
 */
mutations.SET_EXCHANGEHISTORY = (state, value) => {
  state.exchange.exchangeList = value;
};

/**
 * exchange 내역 현재 페이지
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_EXCHANGELISTPAGENO = (state, value) => {
  state.exchange.exchangeListPageNo = value;
};

/**
 * exchange 내역 시작일
 * @param {*} state
 * @param {String} value
 */
mutations.SET_EXCHANGELISTSTARTDATE = (state, value) => {
  state.exchange.exchangeListStartDate = value;
};

/**
 * exchange 내역 종료일
 * @param {*} state
 * @param {String} value
 */
mutations.SET_EXCHANGELISTENDDATE = (state, value) => {
  state.exchange.exchangeListEndDate = value;
};

/**
 * exchange 내역 상태
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_EXCHANGELISTSTATUS = (state, value) => {
  state.exchange.exchangeListStatus = value;
};

/**
 * exchange 상세 내역
 * @param {*} state
 * @param {Number} value
 */
mutations.SET_EXCHANGEDETAIL = (state, value) => {
  state.exchange.exchangeDetail = value;
};

/**
 * exchange 상세 내역에서 계좌정보 수정
 * @param {*} state
 * @param {Boolean} value
 */
mutations.SET_EXCHANGEDETAILACCOUNT = (state, value) => {
  state.exchange.isDetailAccount = value;
};

mutations.SET_IS_NJPOINT_WITHDRAW = (state, value) => {
  state.exchange.isNjPointWithdraw = value;
};

export default {
  ...mutations,
};
